var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "modal" } }, [
    _c("div", { staticClass: "modal-mask" }, [
      _c(
        "div",
        {
          staticClass: "modal-wrapper",
          class: [_vm.alignMiddle === true ? "alignMiddle" : "alignTop"],
        },
        [
          _c(
            "div",
            {
              staticClass: "modal-container",
              style: { width: _vm.width, height: _vm.height },
            },
            [
              _vm.title !== null
                ? _c("div", { staticClass: "modal-header" }, [
                    _c("div", { staticClass: "modal-header-text" }, [
                      _vm._v(_vm._s(_vm.title)),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "modal-header-close",
                        on: {
                          click: function ($event) {
                            return _vm.$emit("close")
                          },
                        },
                      },
                      [_c("fa", { attrs: { icon: "xmark" } })],
                      1
                    ),
                  ])
                : _vm.$slots.header
                ? _c(
                    "div",
                    [
                      _vm._t("header"),
                      _vm._v(" "),
                      _vm.hideClose === false
                        ? _c("fa", {
                            staticClass:
                              "closeIcon pull-right float-right is-pulled-right",
                            attrs: {
                              icon: ["fal", "times"],
                              size: "lg",
                              title: "Close",
                            },
                          })
                        : _vm._e(),
                    ],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "modal-body",
                  style: { height: _vm.bodyHeight },
                },
                [_vm._t("default"), _vm._v(" "), _vm._t("body")],
                2
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "modal-footer" },
                [
                  _vm._t("footer", function () {
                    return [
                      _c(
                        "button",
                        {
                          staticClass:
                            "btn btn-default pull-right button is-pulled-right",
                          on: {
                            click: function ($event) {
                              return _vm.$emit("close")
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n                            Close\n                        "
                          ),
                        ]
                      ),
                    ]
                  }),
                ],
                2
              ),
            ]
          ),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }